// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__ZjIDv","form":"styles_form__2ELGK"};